import { ForbiddenError } from "@/modules/auth/errors";
import { NotFoundError } from "@/modules/errors";
import { MembershipLimitError } from ".";

const errorsByCode = {
  FORBIDDEN: ForbiddenError,
  MEMBERSHIP_LIMIT: MembershipLimitError,
  NOT_FOUND: NotFoundError,
};

export default function factory(StandardError, error) {
  const code = error.graphQLErrors[0]?.extensions?.code;
  const message = error.graphQLErrors[0]?.message;
  const LukitaError = errorsByCode[code];

  return Promise.reject(
    LukitaError ? new LukitaError(message) : new StandardError(error),
  );
}
